import React from 'react';
import PropTypes from 'prop-types';

import SelectableRow from 'components/selectable_record_table/selectable_row';
import CompanyActions from './company_actions';
import Cell from './company_cell';

export default function CompanyRow({
  cellOverrides,
  columns,
  company,
  onRemoveCompany,
  onUpdateCompany
}) {
  const actionsDropdown = <CompanyActions company={company} onDelete={onRemoveCompany} onEdit={onUpdateCompany} />;
  const renderedColumns = columns.map((columnName) => {
    if (cellOverrides && cellOverrides[columnName]) {
      const OverrideComponent = cellOverrides[columnName];
      return <td key={columnName}><OverrideComponent contactCompany={company} /></td>;
    }

    return <Cell columnName={columnName} contactCompany={company} key={columnName} />;
  });

  return (
    <SelectableRow hideCheckbox={true}>
      {renderedColumns}
      <td>{actionsDropdown}</td>
    </SelectableRow>
  );
}

CompanyRow.propTypes = {
  cellOverrides: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  company: PropTypes.object.isRequired,
  onRemoveCompany: PropTypes.func.isRequired,
  onUpdateCompany: PropTypes.func.isRequired
};
